export default "/_next/static/fonts/tt_norms_pro_extrablack-951bff3e4d02fc96dd07cdd9e0b78002.woff";